"use client";

import { loadStripe } from "@stripe/stripe-js";
import axios, { isAxiosError } from "axios";
import React, { useEffect } from "react";
import { logEvent } from "../analytics/google";
import { type SessionCart, type SessionCartItem } from "@/ui/types";

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY || "");

const API_URL = process.env.NEXT_PUBLIC_MICROGRAPHER_API_URL;

const API_KEY = process.env.NEXT_PUBLIC_MICROGRAPHER_API_KEY;

export default function CheckoutButton({ sessionCart, page }: { sessionCart: SessionCart; page: string }) {
	// useEffect(() => {
	// const query = new URLSearchParams(window.location.search);

	// TODO
	// 	if (query.get("success")) {
	// 		console.log("Order placed! You will receive an email confirmation.");
	// 	}

	// 	if (query.get("canceled")) {
	// 		console.log("Order canceled -- continue to shop around and checkout when you’re ready.");
	// 	}
	// }, []);

	const handleCheckout = async () => {
		try {
			const stripe = await stripePromise;

			// Track click event in GA
			logEvent("Click", "Checkout", `${page}`);

			// items: [
			//   { name: "Product 1", price_id: 'price_1JfgxWJI5JtGn44zDokvkcdz', quantity: 1 },
			// ], currency: "USD"
			const sessionCartCheckoutArr = sessionCart.map((el: SessionCartItem) => {
				return {
					name: el["product_name"],
					stripe_price_id: el["stripe_price_id"],
					quantity: el["quantity"],
				};
			});
			const response = await axios.post(
				`${API_URL}/create-checkout-session`,
				{
					items: sessionCartCheckoutArr,
					currency: "USD",
				},
				{
					withCredentials: true, // Ensure cookies are sent with the request
					headers: {
						"x-api-key": API_KEY,
						"Content-Type": "application/json",
					},
				},
			);

			const session = response.data;

			const result = await stripe?.redirectToCheckout({
				sessionId: session.id,
			});

			if (result?.error) {
				console.error(result.error.message);
			}
		} catch (error) {
			// 409 = a limited edition in the cart sold out before checkout (A.2.4).
			if (isAxiosError(error) && error.response?.status === 409) {
				const detail =
					(error.response.data as { detail?: string })?.detail ??
					"An item in your cart just sold out. Please remove it and try again.";
				alert(detail);
			} else {
				console.error("Error during checkout:", error);
			}
		}
	};

	// New useEffect to handle URL parameter extraction and redirection
	useEffect(() => {
		const processOrder = async (session_id: string) => {
			try {
				const response = await axios.post(
					`${API_URL}/process-order`,
					{},
					{
						withCredentials: true,
						headers: {
							"Content-Type": "application/json",
							"x-api-key": API_KEY,
						},
						params: {
							session_id: session_id,
						},
					},
				);

				const { order_id } = response.data;
				window.location.href = `/order-confirmation?order_id=${order_id}`;
			} catch (error) {
				console.error("Error processing order:", error);
			}
		};

		const query = new URLSearchParams(window.location.search);
		const session_id = query.get("session_id");
		if (session_id) {
			processOrder(session_id);
		}
	}, []);

	return (
		<button
			type="button"
			className="label-caps inline-flex w-full items-center justify-center gap-2 bg-mg-black px-7 py-4 text-bone transition-colors duration-300 ease-gallery hover:bg-mg-gold hover:text-mg-black"
			onClick={handleCheckout}
		>
			Proceed to Checkout
		</button>
	);
}
